import { AxiosError } from "axios";

// Backend error response body: { metadata: { errors: [...] }, data: null }
interface ApiErrorBody {
    metadata?: { errors?: string[] };
    errors?: string[];
}

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
    if (error instanceof AxiosError) {
        // Axios exposes the whole HTTP body as response.data; the message lives in body.metadata.errors
        const body = error.response?.data as ApiErrorBody | undefined;
        return body?.metadata?.errors?.[0] ?? body?.errors?.[0] ?? fallback;
    }
    return fallback;
};